<template>
    <div class="container-fluid">
        <div class="row p-3">
            <div class="col-md-12 px-0">
                <router-link class="back-route h3" ref="backBtn" to="/results/team">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    {{competition.name}}
                </router-link>
            </div>
        </div>

        <div class="tabcontent">
            <div class="fullInputs mb-4 pt-3">
                <div class="twoInputs">
                    <div class="btnInsideInput">
                        <input type="text" id="free_search" class="form-control" v-model="search"
                               placeholder="Search" autocomplete="off"
                               @input="searchTeam" maxlength="50">

                        <button ref="buttonSearch">
                            <img src="../../../assets/images/SearchIcon.png" alt="">
                        </button>
                    </div>
                </div>
                <div class="oneInput">
                    <select id="filter_dates" class="form-select" v-model="sort" @change="getTeamsScored">
                        <option value="false" selected disabled>Sort by Date</option>
                        <option value="asc">Oldest</option>
                        <option value="desc">Latest</option>
                    </select>
                </div>
            </div>

            <div class="table-container">
                <TableComponent :thead="thead" :tbody="newObjectEntity" :keys="keys" @sort="SortCompetition" @update="updateCompetition"
                                model="teamsScoreCompetition" name="teamsScoreCompetition"
                                updateUrl="/edit-scores"/>

                <div class="paginationLink">
                    <pagination :data="laravelData" @pagination-change-page="getTeamsScored" :limit="3">
                        <template #prev-nav>
                            <span>Previous</span>
                        </template>
                        <template #next-nav>
                            <span>Next</span>
                        </template>
                    </pagination>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from 'laravel-vue-pagination';
    import score from "../../../api-services/score";
    import competition from "../../../api-services/competition";

    export default {
        name: 'pageShowTeams-userscore',
        data() {
            return {
                thead: ['Name', 'Score'],
                keys: ['name', 'score'],
                permissions: [],
                teams: [],
                competition: {
                    name: ''
                },
                filteredArray: [],
                newObjectEntity: [],
                originalTeams: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false,
                isSearch: false,
                status2:false,
                isActive1: false,
                isActive2: false
            }
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        async mounted() {
            this.getTeamsScored();
            const compeId = this.$route.params.id;
            const response = await competition.show(compeId);
            this.competition.name = response.data.data.name;
        },
        methods: {
            async getTeamsScored() {
                const competition_id = this.$route.params.id;
                try {
                    const response = await score.teamsOfComeptition(competition_id);
                    // console.log(response.data.data);
                    this.teams = response.data.data;
                    this.formatHandler(response.data.data);
                    this.laravelData = response.data;
                    this.originalTeams = response.data.data;
                } catch (e) {
                    // console.log(e);
                }
            },
            formatHandler(data) {
                let obj = {id:'',name: '', score: 0};
                let totalScore = 0;
                let totalWeight = 0;
                this.newObjectEntity = [];
                let copyScore = [];
                data.forEach((item) => {
                    obj.id = item.id;
                    obj.name = item.name;
                    if(item.isLeader === 'members'){
                        // item.score.filter(scoreItem => scoreItem.id !== item.leader)
                        item.score.forEach((scoreItem) => {
                            if(scoreItem.id !== item.leader){
                                copyScore.push(scoreItem);
                            }
                        })
                    }else{
                        item.score.forEach((scoreItem) => {
                            if(scoreItem.id === item.leader){
                                copyScore.push(scoreItem);
                            }
                        })
                    }

                    console.log(copyScore);
                    for (let i = 0; i < copyScore.length; i++) {
                        if (item.score[i].score === 0 || item.score[i].score === null) {
                            totalScore += 0;
                            totalWeight = item.score[i].totalWeight;
                        } else {
                            totalScore += parseInt( item.score[i].score);
                            totalWeight = item.score[i].totalWeight;
                        }
                    }
                    obj.score = totalScore / copyScore.length;
                    obj.totalWeight = totalWeight;
                    this.newObjectEntity.push(obj);
                    obj = {id:'',name: '', score: 0};
                    totalScore = 0;
                    copyScore = [];

                })
                console.log(this.newObjectEntity);
            },
            async SortCompetition(){
                let status = !this.status2;
                this.originalTeams.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.status2 = status;
            },
            async updateCompetition(e){
                let filteredData = this.teams.filter(function (data) {
                    return data.id != e;
                });
                this.teams = filteredData;
            },
            searchTeam(e){
                let searchedValue = e.target.value;
                let searchedData = this.originalTeams.filter((data) => data.name.includes(searchedValue));
                this.teams = searchedData;
            },
            // async searchBackEndHandler(){
            //     await this.getTeamsScored();
            // }
        }
    }
</script>

<style scoped>
    .styleDataNotFound {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        height: 80%;
    }
</style>